export const CURRENCY_PREFERENCE_COOKIE_NAME = "currencyPreference"

export type CurrencyPreference = "crypto" | "usd"

export const defaultCurrency = "crypto" as const satisfies CurrencyPreference

export function parseCurrency(
  currency: string | undefined,
): CurrencyPreference {
  if (currency !== "crypto" && currency !== "usd") {
    return defaultCurrency
  }
  return currency
}

export function getCurrencyStaticParams() {
  return [{ currency: "crypto" }, { currency: "usd" }]
}

// biome-ignore lint/complexity/noBannedTypes: this is fine as its just a default
export type CurrencyParams<T extends Record<string, string> = {}> = T & {
  currency: CurrencyPreference
}
